<script>
  import { onMount } from 'svelte';
  import { isFittingBoxEnabled } from '$lib/utils/fittingbox';
  import {
    PUBLIC_FITTINGBOX_TOKEN_US,
    PUBLIC_FITTINGBOX_TOKEN_UK,
    PUBLIC_FITTINGBOX_TOKEN_EU
  } from '$env/static/public';
  import { region } from '$lib/region';

  const API_KEYS = {
    eu: PUBLIC_FITTINGBOX_TOKEN_EU,
    uk: PUBLIC_FITTINGBOX_TOKEN_UK,
    us: PUBLIC_FITTINGBOX_TOKEN_US
  };

  const loadFitMixScript = () => {
    const script = document.createElement('script');
    script.src = '//vto-advanced-integration-api.fittingbox.com/index.js';
    script.type = 'text/javascript';
    document.head.appendChild(script);
  };

  onMount(() => {
    if (!isFittingBoxEnabled()) return;

    loadFitMixScript();

    var params = {
      apiKey: API_KEYS[$region],
      lang: 'en',
      css: 'vto-advanced-watermark { display: none !important; }',
      popupIntegration: {
        centeredHorizontal: true,
        centeredVertical: true,
        width: '80vw',
        height: '80vh',
        horizontalOffset: '-7px'
      }
    };

    const initFitMix = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.FitMix) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.fitmixInstance = window.FitMix.createWidget('fitmix-container', params, function () {
          //TODO: Add event listener for when the widget is ready
          // console.log('FitmixWidget creation complete!');
        });
      } else {
        setTimeout(initFitMix, 100);
      }
    };

    initFitMix();
  });
</script>
